import request from '@/utils/request'
let resquest = process.env.VUE_APP_BASE_API

export default {
  /* ---------------------------------小说作品回收站---------------------------- */

  //恢复作品
  novleRestitution(data) {
    return request({
      url: `${resquest}/novel/app/dialogue/async/v3`,
      method: 'post',
      data: data
    })
  },
  //批量删除
  novleRecycleDel(data) {
    return request({
      url: `${resquest}/novel/app/novel/recycle/delete`,
      headers: {
        "Content-Type": 'application/json;charset=utf-8'
      },
      method: 'post',
      data: data
    })
  },
  //清空回收站
  clearNovleRecycle() {
    return request({
      url: `${resquest}/novel/app/novel/recycle/clear`,
      headers: {
        "Content-Type": 'application/json;charset=utf-8'
      },
      method: 'post'
    })
  }

}